import { render, staticRenderFns } from "./index.vue?vue&type=template&id=df9e2482&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=df9e2482&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df9e2482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\aihuz\\arbitration-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df9e2482')) {
      api.createRecord('df9e2482', component.options)
    } else {
      api.reload('df9e2482', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=df9e2482&scoped=true&", function () {
      api.rerender('df9e2482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/commission/allot/index.vue"
export default component.exports